import { render, staticRenderFns } from "./KusDocumentPreviewCard.vue?vue&type=template&id=0b81c01d"
import script from "./KusDocumentPreviewCard.vue?vue&type=script&lang=js"
export * from "./KusDocumentPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./KusDocumentPreviewCard.vue?vue&type=style&index=0&id=0b81c01d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports